import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChartLine, 
  faUsers, 
  faHandshake,
  faHome
} from '@fortawesome/free-solid-svg-icons';
import './QuickNavMenu.css';

const QuickNavMenu = () => {
  const location = useLocation();
  
  const quickLinks = [
    { 
      path: '/dashboard', 
      label: 'Dashboard', 
      icon: faHome,
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    { 
      path: '/leads', 
      label: 'Leads', 
      icon: faUsers,
      gradient: 'linear-gradient(135deg, #e89b5b 0%, #d68559 100%)'
    },
    { 
      path: '/deals', 
      label: 'Deals', 
      icon: faHandshake,
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    }
  ];

  return (
    <Nav className="navbar-nav-quick-links align-items-center">
      {quickLinks.map((link, index) => (
        <Nav.Item key={link.path}>
          <Nav.Link
            as={Link}
            to={link.path}
            className={`d-flex align-items-center px-3 py-2 mx-1 quick-nav-link ${
              location.pathname === link.path ? 'active' : ''
            }`}
            style={{
              borderRadius: '25px',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              if (location.pathname !== link.path) {
                e.currentTarget.style.background = link.gradient;
                e.currentTarget.style.color = '#fff';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
              }
            }}
            onMouseLeave={(e) => {
              if (location.pathname !== link.path) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#6b7280';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }
            }}
          >
            <FontAwesomeIcon 
              icon={link.icon} 
              className="me-2"
              style={{ fontSize: '16px' }}
            />
            <span style={{ fontWeight: '600', fontSize: '14px' }}>
              {link.label}
            </span>
          </Nav.Link>
        </Nav.Item>
      ))}
      
      {/* Divider */}
      <div 
        className="mx-3 d-none d-lg-block"
        style={{
          width: '1px',
          height: '30px',
          background: 'linear-gradient(180deg, transparent, #e5e7eb, transparent)'
        }}
      />
    </Nav>
  );
};

export default QuickNavMenu;